module.exports = __webpack_public_path__ + "img/0109.f2d627b5.png";